import { ReactElement } from 'react';

import { currencyWithCents } from '~/lib/format';

export default function DealPrice({
  subtotal,
  hasPlus,
  subtotalAfterDiscounts,
  isSubscriptionDeal,
  hasCoupon,
}: {
  subtotal: number | null;
  hasPlus: boolean;
  subtotalAfterDiscounts: number | null;
  isSubscriptionDeal: boolean;
  hasCoupon: boolean;
}): ReactElement {
  let priceClass = 'font-medium';
  let originalPriceEl = null;

  if (subtotalAfterDiscounts === null) return <></>;

  if (
    subtotal &&
    subtotal > 0 &&
    (hasCoupon || hasPlus) &&
    !isSubscriptionDeal
  ) {
    if (hasCoupon) {
      priceClass = 'font-medium text-dollar';
    } else if (hasPlus) {
      priceClass = 'font-medium text-brick';
    }

    originalPriceEl = (
      <div
        className="ml-2 text-sm text-grace line-through"
        data-testid="deal-item-original-price"
      >
        {currencyWithCents(subtotal)}
      </div>
    );
  }

  return (
    <>
      <div className={priceClass} data-testid="deal-item-price">
        {currencyWithCents(subtotalAfterDiscounts)}
        {isSubscriptionDeal ? '/year' : ''}
      </div>
      {originalPriceEl}
    </>
  );
}

export { DealPrice };
